import { useEffect, useState } from "react";
import { CommonHeader } from "../../../components/commons";
import AllClientBulkUpload from "../../../components/AdminReports/BulkUploadReport/AllClientBulkUpload/AllClientBulkUpload";
import HRMSBulkUpload from "../../../components/AdminReports/BulkUploadReport/HRMSBulkUpload/HRMSBulkUpload";


type TabsType = {
  name: string;
  label: string;
  display: boolean | undefined;
};
const tabs: TabsType[] = [
  {
    name: "All Client Bulk Upload",
    label: "AllClient",
    display: false,
  },
  {
    name: "HRMS Bulk Upload",
    label: "HRMS",
    display: false,
  },
];
type AppProps = {
  history?: any;
};
const BulkUploadReport = ({ history }: AppProps) => {
  const persistActivetab = history?.location?.state?.activeTab;

  const [finalTab, setFinalTab] = useState(tabs);



  const [activeTab, setActiveTab] = useState(
    persistActivetab ? persistActivetab : tabs[0]?.label
  );


  useEffect(() => {
    if (persistActivetab) {
      setActiveTab(persistActivetab);
    }
  }, [persistActivetab]);

  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
  };
  const renderTabs = () => {
    const finalTabs = finalTab?.map((tab: TabsType) => {
      return (
        <div
          key={tab?.label}
          className={tab.display ? "tab-style mr-4 pointer" : "pointer"}
          onClick={() => {
            handleTabChange(tab?.label);
          }}
        >
          <div
            style={{
              padding: "12px 16px 12px 5px",
              color: activeTab === tab?.label ? "#dd4433" : "",
              fontSize: "16px",
            }}
            className={`tab-header ${activeTab === tab?.label ? "active" : ""}`}
          >
            {tab?.name}
          </div>
          <div
            className={`${
              activeTab === tab?.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });
    return finalTabs;
  };

  const activeTabRender = () => {
    switch (activeTab) {
      case "AllClient":
        return (
          <AllClientBulkUpload
            activeTab={activeTab}
            history={history}
    
          />
        );
      case "HRMS":
        return (
          <HRMSBulkUpload
            activeTab={activeTab}
            history={history}

          />
        );

      default:
        return (
          <AllClientBulkUpload
            activeTab={activeTab}
            history={history}
           
          />
        );
    }
  };
  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <CommonHeader title="All Bulk Upload" />
        </div>
      </div>
      <div className="col-md-12 mt-4">
        <div
          style={{
            background: "#d8dee4",
            borderRadius: "5px 5px 0 0",
            padding: "0px 15px",
          }}
        >
          <div
            className="d-flex align-items-center"
            style={{ justifyContent: "space-between" }}
          >
            <div className="d-flex">{renderTabs()}</div>
            <div>
             
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-12">
        <div style={{ border: "1px solid #bfcbe1", backgroundColor: "#fff" }}>
          {activeTabRender()}
        </div>
      </div>
    </>
  );
};

export default BulkUploadReport;

